







































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Airline, ApiError } from '@/api';
import { snackModule, authModule } from '@/store';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';

@Component({
  components: {
    ConfirmDialog,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  airline: Airline | null = null;

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  get airlineId() {
    return this.$route.params.airlineId;
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.airline && this.airline.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async save() {
    if (!this.airline) {
      return;
    }

    try {
      await this.airline.save();
      if (
        this.$route.name === 'admin-airlines-add' &&
        this.airline &&
        this.airline.id
      ) {
        this.$router.push({
          name: 'admin-airlines-edit',
          params: { airlineId: this.airline.id },
        });
        snackModule.showSnackbar('Airline Created');
      } else {
        snackModule.showSnackbar('Airline Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-airlines-edit' && this.airlineId) {
      try {
        this.airline = (await Airline.find(this.airlineId)).data;
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Airline not found');
      }
    } else {
      this.airline = new Airline();
    }
  }
}
